const Dot = ({ color = "bleu", className }) =>
  <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="3"
      height="3"
      viewBox="0 0 3 3"
      className="shrink-0"
      aria-hidden
    >
      <path d="M2.23614 0H0V2.27974H2.23614V0Z" className={`fill-${color}`} />
    </svg>

export default Dot;
